import { Component, Input, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { isLastItem } from '../../utils/is-last-item.util';

@Component({
  selector: 'app-radio-input',
  templateUrl: 'radio-input.component.html',
  styleUrls: ['radio-input.component.scss']
})
export class RadioInputComponent implements ControlValueAccessor {
  @Input() id: string;
  @Input() name: string;
  @Input() mandatory: boolean;
  @Input() helpTooltipText: string;
  @Input() options: string[];
  @Input() displayHorizontally: boolean;
  @Input() isDisabled: boolean;

  @Input() defaultValue: string;

  public value: string;

  constructor(@Self() public controlDirective: NgControl) {
    controlDirective.valueAccessor = this;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onChange: any = () => {};

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onTouched: any = () => {};

  public writeValue(value: string) {
    this.value = value;
  }

  public registerOnChange(fn: any) {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  public handleInput(value: string) {
    if (!this.isDisabled) {
      this.value = value;

      this.onTouched();

      this.onChange(this.value);
    }
  }

  public isLastItem(array: any[], index: number) {
    return isLastItem(array, index);
  }

  public checked(option){
     if(this.defaultValue != null)
        return option == this.defaultValue;

     return this.value === option;

  }
}
